import axios from "axios";
export function postLogin(data) {
  return new Promise((resolve, reject) => {
    axios.post("auth/login", data)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  })
}